import utils from '../../utils/util';
import store from '../../store';
import { clientIdentityService } from '../intendedCar.service';
import layerManager from '../layer.manager';
export default {
  showSharedRedPacket (dealerId) {
    if (!utils.browser.isApp) {
      return;
    }
    store
      .dispatch('getFunctionData')
      .finally(function () {
        const salesInfo = store.state.sales.salesInfo;
        clientIdentityService
          .getClientId()
          .then(result => {
            return store.dispatch('intended/getIntendRedpacket', {
              dealerId: dealerId,
              ...result
            });
          })
          .then(redPacketList => {
            if (redPacketList.length > 0) {
              layerManager.openShareRedPacket({
                propsData: { redPacketList, salesId: salesInfo.salesId }
              });
            }
          });
      });
  }
};